<template>
  <v-container
    class="buy-offers-view-container"
    fluid
  >
    <h1>BuyOffers</h1>
    <BuyOffersTable
      :buyoffers="buyoffers"
      :buyoffers-pagination="pagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { setQuery } from '@/helpers';
import { BuyOffersTable } from '@/components/trades';

export default {
  name: 'BuyOffers',
  components: {
    BuyOffersTable,
  },
  computed: {
    ...mapState({
      loading: state => state.buyOffersStore.loading,
      buyoffers: state => state.buyOffersStore.buyoffers,
      pagination: state => state.buyOffersStore.pagination,
    }),
  },
  async mounted() {
    const { query } = this.$route;
    const params = { ...this.pagination, ...query };

    setQuery(
      {
        ...params,
      },
      this.$route,
      this.$router,
    );
  },
};
</script>
<style scoped>
.buy-offers-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/BuyOffers.vue